var map = {
	"../authentication/authentication.module": [
		"./src/app/authentication/authentication.module.ts",
		"common",
		"authentication.module"
	],
	"../error/error.module": [
		"./src/app/error/error.module.ts",
		"common"
	],
	"./mabble-instance/mabble-instance.module": [
		"./src/app/mabble-instance/mabble-instance.module.ts",
		"common",
		"mabble-instance.module"
	],
	"./spike/spike-scratch.module": [
		"./src/app/spike/spike-scratch.module.ts",
		"common",
		"spike-scratch.module"
	],
	"@cms/content-manager.module": [
		"./src/app/content-manager/content-manager.module.ts",
		"common"
	],
	"@codes/codes-file.module": [
		"./src/app/lookup/codes-file.module.ts",
		"common",
		"codes-file.module"
	],
	"@config/configuration.module": [
		"./src/app/configuration/configuration.module.ts",
		"common",
		"configuration.module"
	],
	"@dataloader/dataloader-router.module": [
		"./src/app/dataloader/dataloader-router.module.ts",
		"common"
	],
	"@forms/form-builder.module": [
		"./src/app/form/form-builder.module.ts",
		"common"
	],
	"@grants/grant-management-router.module": [
		"./src/app/grant-management/grant-management-router.module.ts",
		"common"
	],
	"@kbms/knowledge-base.module": [
		"./src/app/knowledge-base/knowledge-base.module.ts",
		"common",
		"knowledge-base.module"
	],
	"@participants/participant.module": [
		"./src/app/participants/participant.module.ts",
		"common",
		"participant.module"
	],
	"@sat/assessment-manager.module": [
		"./src/app/assessment-manager/assessment-manager.module.ts",
		"common"
	],
	"@user/users.module": [
		"./src/app/users/users.module.ts",
		"common"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_lazy_route_resource lazy
// module id = ./src/$$_lazy_route_resource lazy recursive
// module chunks = main